import React from 'react';
import { assertDefined } from '~/helpers/data';
import usePageContext from '../page-context';
import RawHTML from '~/components/jsx-helpers/raw-html';
import './leadership.scss';
function Bio({ imageUrl, name, contact, bio, title }) {
    return (React.createElement("div", { className: "bio" },
        React.createElement("div", { className: "card" }, imageUrl !== null && React.createElement("img", { src: imageUrl, alt: name })),
        React.createElement("div", { className: imageUrl ? '' : 'span-2' },
            React.createElement("div", { className: "name" }, name),
            React.createElement("div", null, title),
            contact && React.createElement("div", null, contact)),
        React.createElement(RawHTML, { className: "span-2", html: bio })));
}
export default function Leadership() {
    const pageData = assertDefined(usePageContext());
    const blurb = pageData.expertsBlurb;
    const bios = pageData.expertsBios.map((b) => ({
        imageUrl: b.expertImage,
        name: b.name,
        title: b.title,
        contact: b.email,
        bio: b.bio
    }));
    return (React.createElement("div", { className: "leadership" },
        React.createElement("div", { className: "heading" },
            React.createElement("h2", null, "Senior leadership"),
            React.createElement(RawHTML, { html: blurb })),
        bios.map((bio) => (React.createElement(Bio, Object.assign({}, bio, { key: bio.name })))),
        React.createElement("div", { className: "bottom-link" },
            React.createElement("a", { href: "/team" }, "Meet the full team"))));
}
